export default "__VITE_ASSET__99a84ad2__"